<template>
  <div class="house-importer-import-prod-stage" v-if="isSending === false">
    <app-panel title="Перенос в прод. базу" v-if="isMounted">
      <div class="house-importer-import-prod-stage__row">

        <div class="house-importer-import-prod-stage__col">
          <div class="house-importer-import-prod-stage__row">
            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-v-select :options="[]" v-model="prodBody.unpassed_marks"
                            :multiple="true"
                            taggable push-tags no-drop :close-on-select="false" searchable
                            :reduce-function="opt => opt"
                            label="То что записано в имени пользователя для непринятых квартир"
                            placeholder="-"
                            :useDynamicKey="false"
              >
                <div slot="help">
                  Нажмите <span style="font-weight: 500">Enter</span> после ввода разделителя
                </div>
              </app-v-select>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-datepicker v-model="prodBody.last_month" label="Последний месяц с нормально рассчитаными начислениями" format="MMMM yyyy" minimum-view="month"/>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-input v-model="prodBody.mcs_id" label="Management companies id" vtype="uint" placeholder="13"/>
            </div>


            <template v-if="isExistentLE">
              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-v-select label="Юридическое лицо" :options="LE" select-label="name"  v-model="prodBody.existent_le">

                </app-v-select>
              </div>
              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f" style="text-align: center">
                <span class="link-icon" @click="isExistentLE = false">
                  Добавить новое Юридическое лицо
                </span>
              </div>
            </template>
            <template v-else>
              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-input v-model="prodBody.le_name" label="Название Юр. лица УК"/>
              </div>

              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-input v-model="prodBody.le_short_name" label="Короткое название Юр. лица УК"/>
              </div>

              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-input v-model="prodBody.inn" label="ИНН" vtype="uint"/>
              </div>

              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-input v-model="prodBody.kpp" label="КПП" vtype="uint"/>
              </div>

              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-input v-model="prodBody.bank_account" label="Счет" vtype="uint"/>
              </div>

              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-input v-model="prodBody.bank_name" label="Название банка (макс. 45 символов)"/>
              </div>

              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-input v-model="prodBody.bik" label="БИК" vtype="uint"/>
              </div>

              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
                <app-input v-model="prodBody.k_account" label="Корр. счет" vtype="uint"/>
              </div>

              <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f" style="text-align: center">
                <span class="link-icon" @click="isExistentLE = true">
                  Выбрать Юридическое лицо из существующих
                </span>
              </div>
            </template>
          </div>
        </div>
        <div class="house-importer-import-prod-stage__col">
          <div class="house-importer-import-prod-stage__row">
            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <div>
                <label class="app-input__label">Тип помещений</label>

                <div class="house-importer-import-prod-stage__checkboxs">
                  <vs-checkbox v-model="prodBody.apt_types" :vs-value="0">Жилое</vs-checkbox>
                  <vs-checkbox v-model="prodBody.apt_types" :vs-value="1">Апартаменты</vs-checkbox>
                  <vs-checkbox v-model="prodBody.apt_types" :vs-value="2">Коммерческое</vs-checkbox>
                  <vs-checkbox v-model="prodBody.apt_types" :vs-value="3">Паркинг</vs-checkbox>
                </div>

              </div>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-input v-model="prodBody.area_all" label="Общая площадь" vtype="udouble"/>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-input v-model="prodBody.area_living" label="Жилая площадь" vtype="udouble"/>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-input v-model="prodBody.area_notliving" label="Нежилая площадь" vtype="udouble"/>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-input v-model="prodBody.area_common" label="Площадь МОП" vtype="udouble"/>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-input v-model="prodBody.area_common_calc" label="Площадь МОП для расчета" vtype="udouble"/>
            </div>
          </div>
        </div>
        <div class="house-importer-import-prod-stage__col">
          <div class="house-importer-import-prod-stage__row">
            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-input v-model="prodBody.cw_std_cons" label="Норматив ХВС" vtype="udouble"/>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-input v-model="prodBody.hw_std_cons" label="Норматив ГВС" vtype="udouble"/>
            </div>

            <div class="house-importer-import-prod-stage__col house-importer-import-prod-stage__col_f">
              <app-v-select :options="[]" v-model="prodBody.ee_std_cons"
                            :multiple="true"
                            taggable push-tags no-drop :close-on-select="false" searchable
                            :reduce-function="opt => opt"
                            label="Значения нормативов по ЭЭ которые встречаются в промежуточной базе"
                            placeholder="1.23"
                            :useDynamicKey="false"
              >
                <div slot="help">
                  Нажмите <span style="font-weight: 500">Enter</span> после ввода норватива. Дробные числа пишите через точку
                </div>
              </app-v-select>
            </div>
          </div>
        </div>
      </div>
    </app-panel>

    <div class="house-importer-import-prod-stage__send-button">
      <app-button color="success" @click="askUser">Отправить</app-button>
    </div>
  </div>
  <div v-else-if="isSending === true" class="content-full-page import-source-stage-post-sending" >
    <div class="block-loading" />
    <template v-if="queueCount === null">
      {{importInfo.status ? importInfo.status : 'Импортируем файлы...'}}
    </template>
    <template v-else>
      {{`Осталось объектов в очереди ${queueCount}...`}}
    </template>
  </div>
</template>

<script>
  export default {
    name: "ImportProdStage",
    props: {
      importInfo: {}
    },
    data() {
      return {
        isExistentLE: true,
        prodBody: {
          unpassed_marks: [],
          last_month: null,
          mcs_id: 13,
          le_name: null,
          le_short_name: null,
          inn: null,
          kpp: null,
          bank_account: null,
          bank_name: null,
          bik: null,
          k_account: null,
          apt_types: [],
          area_all: 0,
          area_living: 0,
          area_notliving: 0,
          area_common: 0,
          area_common_calc: 0,
          cw_std_cons: null,
          ht_std_cons: null,
          existent_le: null,
          ee_std_cons: []
        },
        queueTimer: null,
        isSending: false,
        queueCount: null,
        isMounted: false,
        LE: [],
      }
    },
    methods: {
      resetProdBody() {
        this.queueCount = null;
        this.isExistentLE = true;
        this.prodBody = {
          unpassed_marks: [],
          last_month: null,
          mcs_id: 13,
          le_name: null,
          le_short_name: null,
          inn: null,
          kpp: null,
          bank_account: null,
          bank_name: null,
          bik: null,
          k_account: null,
          apt_types: [],
          area_all: 0,
          area_living: 0,
          area_notliving: 0,
          area_common: 0,
          area_common_calc: 0,
          cw_std_cons: null,
          existent_le: null,
          hw_std_cons: null,
          ee_std_cons: []
        }
      },
      askUser(){
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: 'Подтверждение',
          text: 'Вы заполнили все известные поля?',
          acceptText: 'Да',
          cancelText: 'Нет',
          accept: () => {
            this.sendBody();
          }
        });
      },
      async sendBody(){
        let body = Object.assign({},{import_id: this.importInfo.id}, this.prodBody);
        body.apt_types = body.apt_types.join(',');
        body.unpassed_marks = JSON.stringify(body.unpassed_marks);
        body.ee_std_cons = JSON.stringify(body.ee_std_cons);
        body.last_month = body.last_month === null ? null : this.$options.filters.moment(body.last_month, 'YYYY-MM');

        if(this.isExistentLE){
          delete body.le_name;
          delete body.le_short_name;
          delete body.inn;
          delete body.kpp;
          delete body.bank_account;
          delete body.bank_name;
          delete body.bik;
          delete body.k_account;
        }
        else{
          delete body.existent_le;
        }
        this.clearTimer();
        try{
          this.isSending = true;
          let {data} = await this.$http.post('import/houses/stage_3', body);

          if(data === 'done'){
            this.updateQueueCount();
            this.setTimer();
          }
          else{
            this.isSending = false;
            this.$vs.notify({color: 'danger', title: 'UNKNOWN ANSWER', text: data});
          }
        }
        catch(e) {
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.isSending = true;
        }
      },
      async updateQueueCount(){
        try{
          let {data} = await this.$http.get('import/houses/queue_status');
          this.queueCount = data.queued_tasks_count;
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
        }
      },
      setTimer(){
        this.queueTimer = setInterval(() => {
          this.updateQueueCount();
        }, 10000);
      },
      clearTimer(){
        clearInterval(this.queueTimer);
        this.queueTimer = null;
        this.queueCount = null;
      },
      async getLE(){
        try{
          let {data} = await this.$http.get('import/houses/legal_entities');
          this.LE = data;
        }
        catch(e){
          this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          this.LE = [];
        }
      }
    },
    created() {
      this.resetProdBody();
      this.getLE();
    },
    mounted(){
      if (this.importInfo.files_parameters && this.importInfo.files_parameters.mid_to_prod) {
        this.$nextTick(() => {
          this.$set(this.prodBody, 'unpassed_marks', this.importInfo.files_parameters.mid_to_prod.unpassed_marks);
          this.$set(this.prodBody, 'last_month', this.$parseDateFromString(this.importInfo.files_parameters.mid_to_prod.last_calculated_month));
          this.$set(this.prodBody, 'mcs_id', this.importInfo.files_parameters.mid_to_prod.mcs_id);

          if(this.importInfo.files_parameters.mid_to_prod.legal_data){
            let data = this.importInfo.files_parameters.mid_to_prod.legal_data;
            this.$set(this.prodBody, 'le_name', data.name);
            this.$set(this.prodBody, 'le_short_name', data.short_name);
            this.$set(this.prodBody, 'inn', data.inn);
            this.$set(this.prodBody, 'kpp', data.kpp);
            this.$set(this.prodBody, 'bank_account', data.bank_account);
            this.$set(this.prodBody, 'bank_name', data.bank_name);
            this.$set(this.prodBody, 'bik', data.bik);
            this.$set(this.prodBody, 'k_account', data.k_account);
          }

          if(this.importInfo.files_parameters.mid_to_prod.buildings_data){
            let data = this.importInfo.files_parameters.mid_to_prod.buildings_data;
            this.$set(this.prodBody, 'apt_types', data.apt_types !== null ? data.apt_types.split(',').map(v => Number(v)) : []);
            this.$set(this.prodBody, 'area_all', data.area_all);
            this.$set(this.prodBody, 'area_living', data.area_living);
            this.$set(this.prodBody, 'area_notliving', data.area_notliving);
            this.$set(this.prodBody, 'area_common', data.area_common);
            this.$set(this.prodBody, 'area_common_calc', data.area_common_calc);
          }

          if(this.importInfo.files_parameters.mid_to_prod.standard_consumptions){
            let data = this.importInfo.files_parameters.mid_to_prod.standard_consumptions;
            this.$set(this.prodBody, 'cw_std_cons', data.cold_water);
            this.$set(this.prodBody, 'hw_std_cons', data.hot_water);
          }

        });
      }

      this.$nextTick(() => {
        this.isMounted = true;
      });
    },
    beforeDestroy() {
      this.clearTimer();
    }
  }
</script>

<style lang="scss">
  .house-importer-import-prod-stage {

    &__row{
      margin: 0 -7.5px;
      display: flex;
      flex-wrap: wrap;
    }

    &__col {
      padding: 0 7.5px;
      flex: 0 0 33.33%;
      width: 33.333%;

      &_f{
        margin-bottom: 15px;
        flex: 0 0 100%;
        width: 100%;
      }
    }

    &__checkboxs{
      display: flex;
      margin-top: 5px;

      .con-vs-checkbox{
        margin: 0;
        margin-right: 15px;

        .con-slot-label {
          line-height: 1.1;
          color: #627084;
          font-size: 14px;
        }
      }
    }

    &__send-button {
      position: fixed;
      right: 15px;
      bottom: 15px;
    }
  }

  .import-source-stage-post-sending{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .block-loading{
      width: 100px;
      height: 100px;
      flex: 0;
      margin-bottom: 15px;
    }
  }
</style>